import waterphone from 'url:./platypus.mp3'
const waterphoneSound = new Audio(waterphone);

export const playWaterphone = () => {
  waterphoneSound.play();
}
